export function createId(): string {
  return (Math.random() * 0x7FFFFFFF | 0).toString();
}
